export default "__VITE_ASSET__erBuyIfJ__"